"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  query EditorialLandingPage(\n    $pageId: ID!\n    $landingPageId: ID\n    $includeThemeItems: Boolean! = true\n    $includeRoot: Boolean! = false\n  ) {\n    application {\n      ...EditorialCategoryPage\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.editorialLandingPageQuery = void 0;
var _fetching = require("@ori/fetching");
var _editorialCategoryPageFragment = require("./editorialCategoryPageFragment");
const editorialLandingPageQuery = exports.editorialLandingPageQuery = (0, _fetching.gql)(_templateObject(), _editorialCategoryPageFragment.editorialCategoryPageFragment);
